<div id="layout-h" class="theme-blue">

    <!-- menu toggle mobile -->
    <i *ngIf="false" class="fa fa-bars nav-link p-2 p-lg-3 d-block d-xl-none menu-toggle me-2 me-lg-0"></i>

    <app-side-bar [selectedEmpresa]="selectedEmpresa"></app-side-bar>
    <!-- sidebar -->
    <!-- sidebar -->

    <!-- main body area -->
    <div class="main px-xl-5 px-lg-4 px-md-3">

        <!-- Body: Header -->
        <div class="body-header border-bottom d-flex py-3">
            <div class="container-fluid">
                <div class="row align-items-center">
                    <div class="col">
                        <!-- <small class="text-muted">Welcome to back.</small> -->
                        <div class="btn-group">
                            <button (click)="toggleEmpresaOptions()" type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown-menu" aria-haspopup="true" aria-expanded="false" [disabled]="noEmpresas">
                              Empresa
                            </button>
                        </div>
                        <div *ngIf="openEmpresaOptions" class="empresa-options-container">
                            <div *ngFor="let org of organizations" (click)="onSelectedEmpresa(org)" class="drop-empresas">
                                <div class="empresa-opt">
                                    {{org}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div> <!-- Row end  -->
            </div>
        </div>

        <!-- Body: Body -->
        <div class="body d-flex py-lg-4 py-3">
            <div class="container-fluid">
                <router-outlet></router-outlet>
            </div>
        </div>

        <!-- Body: Footer -->
        <div class="body-footer d-flex">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="card mb-3 border-0">
                            <div class="card-body">
                                <div class="row justify-content-between align-items-center">
                                    <div class="col pull-right">
                                        Hecho con <i class="fa fa-heart text-danger"></i> por <a href="https://www.gestionatupyme.cl"
                                            target="_blank">GestionaTuPyme</a>
                                    </div>
                                    <div class="col pull-left">
                                        GestionaTuPyme &copy; 2023 - 1.5
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> <!-- .row end -->
            </div>
        </div>

    </div>

</div>
